import request, { PATCH } from '../../utils/request';

export default body => request('/receptacles', { method: PATCH, body });
